module.exports = __webpack_public_path__ + "images/icon/textClosed-3e9b037e.svg";